
import router from '@/router/index'
import packageService from '@/api/packageConfigService'
// import Vue from "vue";



const state = {

    module: [],
    packs: [],
    newPackage: {},
    edit: false,
    products: []
}
const getters = {
    packModule: state => state.module,
    PackageData: state => state.packs,
    newPackage: state => state.newPackage,
    edit: state => state.edit,

};

const actions = {

    async addPackage({ commit }, pack) {
        await packageService.addPackage(pack)

        commit('add', pack)
    },
    async editPackage({ commit }, pack) {
        await packageService.getPackageById(pack.id)

        commit('edit', pack)
    },
    async updatePackage({ commit, rootState }, pack) {
        var t = pack.Modules;
        var value = [];
        t.map(item => {
            value.push({ id: item.ID });
        });

        let data = {
            modules: value,
            productID: pack.productID,
            id: pack.id,
            name: pack.Name
        }
        await packageService.updatePackage(pack.id, pack)
        const index = rootState.packageData.map(item => item.id).indexOf(pack.id)
        rootState.packageData[index] = data;
        commit('update', pack)
    },
    async removePackage({ commit, rootState }, pack) {
        await packageService.removePackage(pack.dataItem.id)
        var packageData = rootState.packageData
        const index = packageData.map(item => item.id).indexOf(pack.dataItem.id)
        packageData.splice(index, 1)
        commit('remove', pack)
    },
    async getModule({ commit }, ) {
        const response = await packageService.getModule();
        commit('getModuleValue', response.data.result)

    }
}
const mutations = {

    getModuleValue(state, pack) {

        state.module = pack
        console.log("data in store", pack)
    },
    add(state, pack) {
        state.packs.push(pack);
        state.newPackage = { modules: {} }
    },
    edit(state, pack) {
        state.editId = pack.id
        state.edit = true
        let modules = state.module

        state.module = modules





        state.newPackage = pack
        router.push({ name: "addPackage", params: { add: true } });
    },
    update(state) {

        state.newPackage = { modules: {} }

    },
    remove(state, pack) {
        var packs = state.packs
        const index = packs.map(item => item.id).indexOf(pack.id)
        packs.splice(index, 1)
    },
    cancel(state) {
        state.newPackage = { modules: {} }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}